export default __webpack_public_path__ + "static/media/StreetChildren_icon.f6745fa4.png";